import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import { Button, rem } from 'design-system';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { selectTradingAccount } from '../reducers/selectors';
import { selectCanSellForTradingAccount } from '../hooks/selectors';
import SellSecclAssetOptionsModal from './SellSecclAssetOptionsModal';
import { IsaAllowanceFormatted, JisaAllowanceFormatted } from '../constants';
import SelectDepositToInvestmentAccountMethodModal from './SelectDepositToInvestmentAccountMethodModal';
const strings = {
    allowanceMaxedTitle: `You’ve reached your annual allowance`,
    isaAllowanceMaxedSubtitle: (<Text TextThin-14 Secondary>
      You’ve already deposited{' '}
      <Text NumbersThin-14 Secondary>
        {IsaAllowanceFormatted}
      </Text>{' '}
      this tax year. You can add more once the new tax year begins.
    </Text>),
    jisaAllowanceMaxedSubtitle: (<Text TextThin-14 Secondary>
      You’ve already deposited{' '}
      <Text NumbersThin-14 Secondary>
        {JisaAllowanceFormatted}
      </Text>{' '}
      this tax year. You can add more once the new tax year begins.
    </Text>),
    okay: 'Okay',
};
const TopUpSecclAccount = () => {
    const styles = useStyles(styleSet);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const canSell = useAppSelector(selectCanSellForTradingAccount);
    const handleSell = useCallback(() => {
        SellSecclAssetOptionsModal.show();
    }, []);
    const handleDeposit = useCallback(() => {
        if (tradingAccount) {
            const { accountType } = tradingAccount.account;
            const remainingAllowance = 
            // eslint-disable-next-line no-nested-ternary
            accountType === 'ISA'
                ? tradingAccount.account.isaRemainingAllowanceAfterPending
                : accountType === 'JISA'
                    ? tradingAccount.account.jisaRemainingAllowanceAfterPending
                    : undefined;
            if (remainingAllowance && remainingAllowance.value <= 0) {
                Modal.showConfirmation({
                    title: 'You’ve reached your annual\nallowance',
                    subtitle: accountType === 'ISA' ? strings.isaAllowanceMaxedSubtitle : strings.jisaAllowanceMaxedSubtitle,
                    confirmButtonTitle: 'Okay',
                });
                return;
            }
            SelectDepositToInvestmentAccountMethodModal.show(undefined, tradingAccount.account, undefined);
        }
    }, [tradingAccount]);
    if (tradingAccount) {
        return (<View style={styles.container}>
        {!!canSell && <Button small flex brandReversed onPress={handleSell} title="Sell"/>}
        <Button small flex brand onPress={handleDeposit} title="Invest"/>
      </View>);
    }
    return null;
};
const styleSet = createStyleSheets(() => ({
    container: {
        gap: rem(16),
        flexDirection: 'row',
        paddingBottom: rem(8),
        paddingHorizontal: rem(16),
    },
}));
export default memo(TopUpSecclAccount);
